<div class="flex-column gap-L">
	<div class="flex-align-center gap-S">
		<div class="font-MM fw-700">{{ 'page.appDetails.overview.informations'|translate }}</div>
		<div *ngIf="advancementPercent < 100" [style.background-color]="advancementPercent > 0 ? '#F2F2F8' : '#DADADA'"
			 style=" height: 5px; border-radius: 2px; width: 30px;">
			<div class="bkg-accent completion-anim" style="height: 5px; border-radius: 2px;"
				 [style.width.%]="advancementPercent"></div>
		</div>
		<img [src]="advancementPercent >= 100 ? 'assets/icons/check-circle-green.svg' : 'assets/icons/check-circle.svg'"
			 height="14px" alt="">
	</div>
	<div class="flex-column">
		<div class="flex-align-center border-light-grey-top" style="height: 50px;">
			<div class="flex-align-center pad-S w-50 border-box">
				<div class="flex-align-center gap-XS w-40">
					<img src="assets/icons/infrastructure_overview/network/role.svg" height="14px"
						 alt="">
					<span class="font-M fw-500 grey">{{ 'page.infrastructure.network.role' | translate }}</span>
				</div>
				<div class="flex-align-center w-60">
					<app-multi-select class="w-100" [inputControl]="roleFormControl"
									  [disabled]="_saving || !isEditor">
						<app-select-trigger
							class="w-100">{{ 'page.infrastructure.network.roles.' + roleFormControl.value | translate }}
						</app-select-trigger>

						<app-select-option *ngFor="let role of networkRoleList"
										   [value]="role">{{ 'page.infrastructure.network.roles.' + role | translate }}
						</app-select-option>
					</app-multi-select>
				</div>
			</div>
			<div class="border-light-grey-left" style="height: 25px"></div>
			<div class="flex-align-center pad-S w-50 border-box">
				<div class="flex-align-center gap-XS w-40">
					<img src="assets/icons/infrastructure_overview/network/vlan-id.svg" height="14px"
						 alt="">
					<span class="font-M fw-500 grey">VLAN ID</span>
				</div>
				<div class="flex-align-center w-60">
					<app-popup-text-input [disabled]="!isEditor" class="w-100" [control]="vlanIdFormControl"
										  (confirm)="updateNetworkInformation()">
						@if (!network.vlanId && isEditor) {
							<app-chips-button popup-trigger>
								<img src="assets/icons/add.svg" class="filter-grey"
									 height="12px" alt="">
								<span
									class="font-M fw-500 grey">{{ 'page.infrastructure.network.addAVlanId' | translate }}</span>
							</app-chips-button>
						} @else if (!network.vlanId && !isEditor) {
							<app-popup-trigger class="w-100">-</app-popup-trigger>
						} @else {
							<app-popup-trigger class="w-100">{{ network.vlanId }}</app-popup-trigger>
						}
					</app-popup-text-input>
				</div>
			</div>
		</div>
		<div class="flex-align-center border-light-grey-top" style="height: 50px;">
			<div class="flex-align-center pad-S w-50 border-box">
				<div class="flex-align-center gap-XS w-40">
					<img src="assets/icons/infrastructure_overview/network/address.svg"
						 height="14px" alt="">
					<div class="flex-align-center">
						<span class="font-M fw-500 grey">{{ 'page.infrastructure.network.address' | translate }}</span>
					</div>
				</div>
				<div class="flex-align-center w-60">
					<app-popup-text-input [disabled]="!isEditor" class="w-100" [control]="ipAddressFormControl"
										  (close)="resetIpAddressFormControl()"
										  [warning]="!isNetworkConfigurationValid(ipAddressFormControl.value, subnetMaskFormControl.value) ? ('page.infrastructure.network.ipError3' | translate) : undefined"
										  (confirm)="updateNetworkInformation()">
						<app-popup-trigger
							[tooltipOffset]="5"
							[tooltip]="'page.infrastructure.network.ipError2' | translate" [tooltipDisabled]="!formGroup.hasError('invalidNetworkAddress') && isNetworkConfigurationValid(ipAddressFormControl.value, subnetMaskFormControl.value)"
							[warning]="formGroup.hasError('invalidNetworkAddress') || !isNetworkConfigurationValid(ipAddressFormControl.value, subnetMaskFormControl.value)"
							class="w-100">{{ network.ipAddress }}
						</app-popup-trigger>
					</app-popup-text-input>
				</div>
			</div>
			<div class="border-light-grey-left" style="height: 25px"></div>
			<div class="flex-align-center pad-S w-50 border-box">
				<div class="flex-align-center gap-XS w-40">
					<img src="assets/icons/infrastructure_overview/network/subnet.svg" height="14px"
						 alt="">
					<span class="font-M fw-500 grey">{{ 'page.infrastructure.network.subnet' | translate }}</span>
				</div>
				<div class="flex-align-center w-60">
					<app-multi-select [emptyPlaceholder]="'page.infrastructure.noLocation'" class="w-100" [inputControl]="subnetMaskFormControl"
									  [disabled]="_saving || !isEditor" [addMinHeight]="true">
						<app-select-trigger
							[tooltipOffset]="5"
							[tooltip]="'page.infrastructure.network.ipError2' | translate" [tooltipDisabled]="!formGroup.hasError('invalidNetworkAddress') && isNetworkConfigurationValid(ipAddressFormControl.value, subnetMaskFormControl.value)"
							[warning]="formGroup.hasError('invalidNetworkAddress') || !isNetworkConfigurationValid(ipAddressFormControl.value, subnetMaskFormControl.value)"
							class="w-100">
							{{ subnetMaskFormControl.value }} ({{ cidrToMask(subnetMaskFormControl.value) }})
						</app-select-trigger>
						<app-select-search [searchControl]="subnetMaskSearchFormControl"></app-select-search>
						<app-select-option *ngFor="let subnet of filteredSubnetMaskList"
										   [value]="subnet">{{ subnet }} ({{ cidrToMask(subnet) }})
						</app-select-option>
					</app-multi-select>
				</div>
			</div>
		</div>
	</div>
</div>
